import { ExclamationCircleIcon } from '@src/assets';
import React from 'react';
import * as styled from './styled/Chip.styled';

export const Chip: React.FC<{
    label: string;
    variant?: string;
}> = ({ label, variant = 'alert' }) => {
    return (
        <styled.Container variant={variant}>
            <ExclamationCircleIcon />
            <styled.Label>{label}</styled.Label>
        </styled.Container>
    );
};
